(() => {
  angular.module("app").directive("csvStyleGuide", () => {
    return {
      restrict: 'A',
      templateUrl: "pages/support/csv-style-guide.html"
    }
  });
})();
